/**
 * Sets up tab tracking for the document.
 * Handles both SSR and CSR scenarios.
 *
 * @param ssrHtml - Optional: HTML string for SSR. If provided, modifies the HTML to include tab tracking classes.
 * @returns A cleanup function for CSR or modified HTML for SSR.
 */
function setTabTracking(ssrHtml) {
    if (ssrHtml !== undefined) {
        if (ssrHtml.includes('class="tab-disabled"'))
            return ssrHtml;
        return ssrHtml.replace('<html', '<html class="tab-disabled"');
    }
    if (typeof document !== 'undefined') {
        const tabbed = (e) => {
            if (e.code === 'Tab') {
                document.documentElement.classList.add('tab-enabled');
                document.documentElement.classList.remove('tab-disabled');
                window.removeEventListener('keydown', tabbed);
                window.addEventListener('mousedown', clicked);
            }
        };
        const clicked = () => {
            document.documentElement.classList.add('tab-disabled');
            document.documentElement.classList.remove('tab-enabled');
            window.removeEventListener('mousedown', clicked);
            window.addEventListener('keydown', tabbed);
        };
        document.documentElement.classList.add('tab-disabled');
        window.addEventListener('keydown', tabbed);
        return () => {
            window.removeEventListener('keydown', tabbed);
            window.removeEventListener('mousedown', clicked);
        };
    }
    return '';
}
/**
 * Generates CSS styles for tab tracking.
 * @returns A string containing CSS rules.
 */
function getTabTrackingStyles() {
    return `
    :root { 
      --tab-outline-color: #656BFC; 
    }
    :root.tab-disabled *[tabindex]:focus { 
      outline: none;
    }
    :root.tab-enabled *[tabindex]:focus { 
      outline-width: 2px;
      outline-style: auto;
      outline-offset: -1px;
      outline-color: var(--tab-outline-color); 
    }
  `;
}
/**
 * Selector for determining if tab tracking is enabled.
 */
const canTabTrack = 'html[class*="tab-enabled"] &';

export { canTabTrack, getTabTrackingStyles, setTabTracking };
